import React from "react";
import { Socials } from "../../components";
import mike_outlined from "../../assets/images/michael-in-circle.png";
import "./About.css";
import { navigateHandler } from "../../helpers";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const aboutDescriptionsContainer = {
  hidden: {
    opacity: 0,
    transition: { when: "beforeChildren" },
  },
  show: {
    opacity: 1,
    transition: {
      duration: 3,
      staggerChildren: 1,
      delayChildren: 0.5,
    },
  },
};

const aboutDescription = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
  },
};

const About = () => {
  return (
    <div id="about">
      <h1>About</h1>
      <motion.div
        initial={{ opacity: 0 }}
        transition={{ duration: 1 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="bg"
      >
        <div className="profile">
          <motion.img
            initial={{ opacity: 0, y: "-20px" }}
            transition={{ duration: 2, delay: 1 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mike-outlined"
            src={mike_outlined}
            alt="Michael Quarcoo"
          />
          <motion.div
            initial={{ x: "-20px", opacity: 0 }}
            transition={{ delay: 1, duration: 2 }}
            whileInView={{ opacity: 1, x: "0px" }}
            viewport={{ once: true }}
            className="name"
          >
            Michael Quarcoo
          </motion.div>
          <Socials />
        </div>
        <motion.div
          variants={aboutDescriptionsContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="description"
        >
          <motion.p variants={aboutDescription}>
            I am a full stack developer with a passion for accelerating
            community growth and development by harnessing the power of software
            engineering.
          </motion.p>
          <motion.p variants={aboutDescription}>
            As someone who loves learning, and gaining new experiences, I
            believe that there's no limit as to how much one can or should
            learn. Without skill acquisition and development, the problems we
            face today will remain unsolved.
          </motion.p>
          <motion.p variants={aboutDescription}>
            My ambition is to contribute to the development of software that
            would help solve problems of global impact. Software that will help
            solve myriads of problems in various spheres of life for people from
            all walks of life.
          </motion.p>
          <Link to="/#portfolio" onClick={navigateHandler}>
            <motion.button
              initial={{ opacity: 0 }}
              transition={{ delay: 3, duration: 1 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="view-portolio-btn"
            >
              View Portfolio
            </motion.button>
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default About;
